<dsy-table zebraShadowRows [data]="tableDataSignal()" [conf]="tableConfSignal()">
  @for (col of columnsSignal(); track col.key) {
    <div [attr.slot]="'header-' + col.key">
      <dsy-heading level-size="lg">{{ col.header }}</dsy-heading>
    </div>
  }
  @for (row of rowsSignal(); track row.id; let i = $index) {
    <p class="world_clock__cell" slot="cell-{{ i }}-market">
      @if (row.market === 'UTC') {
        <dsy-icon [name]="'my_location'" library="material" size="1.2rem" color="#667790"></dsy-icon>
      }
      {{ row.market }}
    </p>
    <p class="world_clock__cell" slot="cell-{{ i }}-timeZone">{{ row.timeZone }}</p>
    <p class="world_clock__cell" slot="cell-{{ i }}-utcOffset">{{ row.utcOffset }}</p>
    <p class="world_clock__cell" slot="cell-{{ i }}-localTime">
      <dsy-icon [name]="row.local.icon" library="material" size="1.2rem" color="#667790"></dsy-icon>
      {{ row.local.time }}
    </p>
  }
</dsy-table>
